import React from 'react'

import Button from '../Button'
import Media from '../Media'

import * as styles from './cta.module.scss'
import { Link } from 'gatsby'
import classNames from 'classnames'
import arrowRightSvg from 'src/images/icons/arrow-right.svg'

export default function Ctas({ ctas, options, className }) {
  return (
    <div className={classNames(styles.ctas, className, 'ctas')}>
      <RenderCtas ctas={ctas} options={options} />
    </div>
  )
}

const RenderCtas = ({ ctas, options }) =>
  ctas.map((cta, idx) => {
    // link or button

    const type = options?.[idx]?.type || 'button'
    const theme = options?.[idx]?.theme
    const btn = options?.[idx]?.btn
    const arrow = options?.[idx]?.arrow

    return (
      <Cta
        key={cta.id}
        {...cta}
        type={type}
        idx={idx}
        theme={theme}
        btn={btn}
        arrow={arrow}
      />
    )
  })

export const Cta = ({
  id,
  href,
  text,
  to,
  icon,
  type,
  idx = 0,
  theme,
  btn = false,
  arrow = false,
}) => {
  if (href) {
    return (
      <a
        href={href}
        target="_blank"
        rel="noreferrer"
        key={id}
        className={classNames(styles.cta, `cta-${idx}`)}
      >
        {type === 'button' ? (
          <Button theme={theme}>
            <span>
              {text}
              {icon && <Media desktop={icon} />}
            </span>
          </Button>
        ) : (
          text
        )}
        {type === 'link' && (
          <img
            className={styles.linkArrow}
            src={arrowRightSvg}
            width="44"
            height="18"
            alt="arrow pointing right"
          />
        )}
      </a>
    )
  }

  if (to) {
    return (
      <Link to={to} key={id} className={classNames(styles.cta, `cta-${idx}`)}>
        {type === 'button' ? (
          <Button theme={theme} btn={btn} arrow={arrow}>
            {text}
          </Button>
        ) : (
          text
        )}
        {type === 'link' && (
          <img
            className={styles.linkArrow}
            src={arrowRightSvg}
            width="44"
            height="18"
            alt="arrow pointing right"
          />
        )}
      </Link>
    )
  }

  return <p style={{ color: 'red' }}>Missing href or to</p>
}
